import { Box, FormControl, FormHelperText, Grid, InputLabel, MenuItem, OutlinedInput, Select, Stack, Typography, useMediaQuery } from '@mui/material';
import { FunctionComponent } from 'react';
import gaiaTheme from '../../../../root-components/theme';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import { IMeasurement } from '../../../../shared/services/category/category.model';
import { EmissionsInputCard } from '../../../../components/presentation-components/emissons-components/overview/emissions-display/emissions-input-card';

export const EmailCampaignEmployeeMethodCommuting: FunctionComponent<{
  formik: any
  isDemonstrationPage: boolean,
  isTest: boolean,
  measurementFilters: IMeasurement[] | undefined,
  selectedData: any,
  filterData: any,
  activeCategoryName: string,
  backgroundColor: string,
  handleFilterSelect: any,
  selectHandler: any,
}> = ({
  formik,
  isDemonstrationPage,
  isTest,
  measurementFilters,
  selectedData,
  filterData,
  activeCategoryName,
  handleFilterSelect,
  selectHandler,
  backgroundColor
}) => {

    const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'));
    const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'));

    const commutingMethods = [{
      method: "Walk",
      icon: IconName.DirectionsWalk
    }, {
      method: 'Cycle',
      icon: IconName.PedalBike
    },
    {
      method: "Motorbike",
      icon: IconName.TwoWheeler
    },
    {
      method: 'Car',
      icon: IconName.DirectionsCarOutlined
    },
    {
      method: 'Taxi',
      icon: IconName.LocalTaxi
    },
    {
      method: 'Bus',
      icon: IconName.DirectionsBus
    },
    {
      method: 'Rail',
      icon: IconName.Train
    },
    {
      method: 'Other',
      icon: IconName.Star
    }
    ]

    return (
      <Box>
        <Typography variant='subtitle1' sx={{ color: 'text.primary', mt: 3, mb: 0.5 }}>Please select your main method of commuting to work?</Typography>
        <Box sx={{
          height: (isDemonstrationPage || isTest) ? '100%' : isMobileModeSm ? '1450px' : isMobileModeMd ? '690px' : '550px'
        }}>
          <Grid container spacing={2} >
            {commutingMethods.map(method => {
              return (
                <Grid item key={method.method} xl={3} lg={3} md={3} sm={4} xs={12} onClick={() => selectHandler(method.method)}>
                  <EmissionsInputCard title={method.method} icon={method.icon} backgroundColor={backgroundColor} selected={activeCategoryName === method.method} padding={1} />
                </Grid>
              )
            })}
          </Grid>
          {
            (isDemonstrationPage || isTest || !activeCategoryName) &&
            <>
              <Stack display='flex' flexDirection='column' sx={{ width: '100%', mt: 2 }}>
                <FormControl>
                  <InputLabel>Additional Information</InputLabel>
                  <Select
                    label='Additional Information'
                    disabled
                    sx={{ mb: 2 }}
                  >
                    <MenuItem >Additional Information</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </>
          }
          {
            activeCategoryName &&
            <>
              <FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
                <FormControl fullWidth variant='outlined'>
                  <Stack display='flex' flexDirection='column' sx={{ width: '100%' }}>
                    {Object.entries(filterData).filter((value, index) => (value[1] as Array<string>)?.length > 0 && index !== 0).map((value, index) => (
                      <FormControl key={index}>
                        <InputLabel>Additional Information</InputLabel>
                        <Select
                          label='Additional Information'
                          id={value[0]} name={value[0]}
                          value={selectedData[value[0]]}
                          onChange={handleFilterSelect}
                          error={formik.touched.detailLevelTwo && Boolean(formik.errors.detailLevelTwo)}
                          sx={{ mb: 2 }}
                        >
                          {(value[1] as Array<string>)?.map((stringValue, index) =>
                            <MenuItem key={index} value={stringValue}>{stringValue}</MenuItem>
                          )}
                        </Select>
                        {formik.touched.detailLevelTwo && formik.errors.detailLevelTwo &&
                          <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                            {formik.errors.detailLevelTwo ? <div>{formik.errors.detailLevelTwo as string}</div> : null}
                          </FormHelperText>
                        }
                      </FormControl>
                    ))}
                  </Stack>
                </FormControl>
              </FormControl>
              {
                measurementFilters &&
                <Grid container spacing={2}>
                  <Grid item xl={8} lg={8} md={8} sm={8} xs={6} >
                    <FormControl fullWidth variant='outlined' sx={{ mb: 2 }}>
                      <InputLabel htmlFor='unitsConsumed'>Distance per Journey</InputLabel>
                      <OutlinedInput inputProps={{ min: 0.01, step: 0.01 }} id='unitsConsumed' label='Distance per Journey' name='unitsConsumed' type='number'
                        value={formik.values.unitsConsumed} onChange={formik.handleChange}
                        error={formik.touched.unitsConsumed && Boolean(formik.errors.unitsConsumed)}
                        sx={{ color: 'text.secondary' }}></OutlinedInput>
                      {formik.touched.unitsConsumed && formik.errors.unitsConsumed &&
                        <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                          {formik.errors.unitsConsumed ? <div>{formik.errors.unitsConsumed as string}</div> : null}
                        </FormHelperText>
                      }
                    </FormControl>
                  </Grid>
                  <Grid item xl={4} lg={4} md={4} sm={4} xs={6}>
                    <FormControl fullWidth variant='outlined' sx={{ flexBasis: '200px' }}>
                      <InputLabel htmlFor='measurementUnitId'> Units</InputLabel>
                      <Select
                        id='measurementUnitId' name='measurementUnitId' label='units'
                        value={formik.values.measurementUnitId}
                        disabled={measurementFilters?.length === 1}
                        onChange={formik.handleChange}
                        error={formik.touched.measurementUnitId && Boolean(formik.errors.measurementUnitId)}
                        sx={{ color: 'text.secondary' }}>
                        {measurementFilters?.map((measurementFilter, index) =>
                          <MenuItem key={index} value={measurementFilter.id}>{measurementFilter.name}</MenuItem>
                        )}
                      </Select>
                      {formik.touched.measurementUnitId && formik.errors.measurementUnitId &&
                        <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                          {formik.errors.measurementUnitId ? <div>{formik.errors.measurementUnitId as string}</div> : null}
                        </FormHelperText>
                      }
                    </FormControl>
                  </Grid>
                </Grid>
              }
            </>
          }
        </Box>
      </Box>
    )
  }